module.exports = __webpack_public_path__ + "img/20_windAndRain_mjj.cde14844.png";